export default "__VITE_PUBLIC_ASSET__4727f059__"